import { render } from "./ReportEventsView.vue?vue&type=template&id=e524538c"
import script from "./ReportEventsView.vue?vue&type=script&lang=js"
export * from "./ReportEventsView.vue?vue&type=script&lang=js"

import exportComponent from "/opt/build/repo/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__